import { CheckoutRedirectAction } from '__generated__/graphql';

import { SUPPORTED_COUNTRY } from './constants';

const getAdyenModule = async (country: SUPPORTED_COUNTRY) => {
  let adyenCheckout = await import('@adyen/adyen-web');

  if (
    process.env.NEXT_PUBLIC_GQL_MOCKS === 'true' &&
    // NOTE: Only AU supports mock adyen tests so far.
    country === SUPPORTED_COUNTRY.AU
  ) {
    adyenCheckout = (await import(
      '../mocks/ui/Adyen/MockAdyen'
    )) as typeof import('@adyen/adyen-web');
  }

  return adyenCheckout;
};

export const isRedirectAction = (
  action: unknown
): action is CheckoutRedirectAction => {
  return (action as CheckoutRedirectAction).type === 'redirect';
};

export default getAdyenModule;
